// getFeedName.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select feed name by template and value
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} dataKey - remote config key.
 * @param {string} template - template string.
 * @param {string} value - template value.
 * @return {string} Return feed name.
 */
const getFeedName = createCachedSelector(
  (state, dataKey) => getRemoteConfigData(state, dataKey),
  (state, dataKey, template) => template,
  (state, dataKey, template, value) => value,
  (feedName = '', template, value) => {
    if (!feedName || !template) {
      return feedName;
    }
    return feedName.replace(template, value);
  }
)((state, dataKey, template, value) => `${dataKey}:${template}:${value}`);

export default getFeedName;
